<template>
  <div class="d-flex flex-row" style="height: 100%">
    <!-- 树形结构 -->
    <div v-if="showTreeData" class="tree-container border">
      <div class="title-head">{{ $t('组织架构筛选') }}</div>
      <div class="p-1">
        <el-input
          ref="input"
          v-model="firstKeyword"
          :placeholder="placeholder"
          :size="size"
          clearable
          @keyup.enter.native="searchFirst"
          @input="searchFirst"
          @clear="clearInput"
        />
      </div>
      <el-scrollbar style="height: 100%">
        <div v-if="!treeList.length">
          <el-empty :image="require('@/assets/404_images/no-data-small.png')" :description="$t('暂无数据')" />
        </div>
        <el-tree
          ref="tree"
          node-key="id"
          :data="treeList"
          :props="treeProps"
          highlight-current
          @node-click="handleNodeClick"
        />
      </el-scrollbar>
    </div>
    <!-- 左侧穿梭框 -->
    <div class="transfer-container d-flex flex-row">
      <div class="transfer-left-container border ml-2">
        <div class="title-head">
          <el-checkbox v-model="leftAllChecked">{{ stayTitle }}</el-checkbox>
        </div>
        <div class="p-1">
          <el-input
            ref="input"
            v-model="secondKeyword"
            :placeholder="placeholder"
            :size="size"
            clearable
            @keyup.enter.native="searchSecond"
            @input="searchSecond"
            @clear="clearInput"
          />
        </div>
        <div class="ml-1" style="height: calc(100% - 70px)">
          <el-scrollbar style="height: 100%">
            <div v-if="!leftList.length">
              <el-empty :image="require('@/assets/404_images/no-data-small.png')" :description="$t('暂无数据')" />
            </div>
            <div v-for="(item, index) in leftList" :key="index" style="height: 28px">
              <div class="pb-1">
                <el-checkbox
                  v-model="item.checked"
                  :disabled="item.disabled"
                  @change="(checked) => handleLeftChange(checked, item)"
                >
                  {{ item.label }}
                </el-checkbox>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <!-- 操作按钮 -->
    <div class="btn-container d-flex flex-column justify-center align-center">
      <el-button type="default" @click="pushToRight"><i class="el-icon-arrow-right"></i></el-button>
      <el-button type="default" style="margin-top: 10px" @click="delFromRight">
        <i class="el-icon-arrow-left"></i>
      </el-button>
    </div>
    <!-- 右侧穿梭框 -->
    <div class="transfer-right-container border">
      <div class="title-head">
        <el-checkbox v-model="rightAllChecked">{{ selectedTitle }}</el-checkbox>
      </div>
      <div class="ml-1 mt-2" style="height: calc(100% - 30px)">
        <div v-if="!objList.length">
          <el-empty :image="require('@/assets/404_images/no-data-small.png')" :description="$t('暂无数据')" />
        </div>
        <el-scrollbar style="height: 100%">
          <draggable animation="300">
            <div v-for="(item, index) in objList" :key="index" style="height: 28px">
              <div class="pb-1">
                <el-checkbox v-model="item.checked">{{ item.label }}</el-checkbox>
              </div>
            </div>
          </draggable>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/lang';

export default {
  name: 'TransferTree',
  components: {
    draggable: (resolve) => require(['vuedraggable'], resolve)
  },
  props: {
    // 是否展示树状
    showTreeData: {
      type: Boolean,
      default: true
    },
    // 树状展示数据
    treeList: {
      type: Array,
      default() {
        return [];
      }
    },
    // 配置树状选项
    treeProps: {
      type: Object,
      default() {
        return {
          children: 'children',
          label: 'label'
        };
      }
    },
    // 搜索框占位文本
    placeholder: {
      type: String,
      default: i18n.t('请输入关键字筛选')
    },
    // 搜索框大小
    size: {
      type: String,
      default: 'small'
    },
    // 左侧穿梭框数据源
    leftTransData: {
      type: Array,
      default() {
        return [];
      }
    },
    // 右侧穿梭框数据源
    rightTransData: {
      type: Array,
      default() {
        return [];
      }
    },
    // 待选标题
    stayTitle: {
      type: String,
      default: i18n.t('待选用户')
    },
    // 已选标题
    selectedTitle: {
      type: String,
      default: i18n.t('已选用户')
    }
  },
  data() {
    return {
      leftAllChecked: false,
      rightAllChecked: false,
      firstKeyword: '',
      secondKeyword: '',
      thireKeyword: '',
      leftList: [],
      objList: [],
      obj: [],
      dragList: []
    };
  },
  watch: {
    dragList(val) {},
    objList: {
      handler: function(val) {
        this.getSelectedVal();
      },
      immediate: true
    },
    leftAllChecked: {
      handler: function(val) {
        const arr = [];
        if (val === true) {
          this.leftList.forEach((item) => {
            if (item.disabled === false) {
              item.checked = true;
              arr.push(item);
            }
          });
          this.obj = this.obj.concat(arr);
        } else {
          this.leftList.forEach((item) => {
            if (item.disabled === false) {
              item.checked = false;
            }
          });
          this.obj = [];
        }
      },
      immediate: true
    },
    rightAllChecked: {
      handler: function(val) {
        if (val === true) {
          this.objList = this.objList.map((item) => {
            return {
              ...item,
              checked: true
            };
          });
        } else {
          this.objList = this.objList.map((item) => {
            return {
              ...item,
              checked: false
            };
          });
        }
      },
      immediate: true
    },
    rightTransData: {
      handler: function(val) {
        this.objList = this.rightTransData;
      },
      immediate: true
    },
    leftTransData: {
      handler: function(val) {
        this.leftList = this.leftTransData;
        this.leftList.forEach((item) => {
          if (this.objList.some((v) => v.key === item.key)) {
            this.$set(item, 'checked', true);
            this.$set(item, 'disabled', true);
          }
        });
      },
      immediate: true
    }
  },
  methods: {
    handleLeftChange(checked, item) {
      if (checked) {
        this.obj.push(item);
      } else {
        this.obj = this.obj.filter((v) => {
          return v.key !== item.key;
        });
      }
      const res = new Map();
      this.obj = this.obj.filter((a) => !res.has(a['label']) && res.set(a['label'], 1));
    },
    // 点击节点时的回调
    handleNodeClick(item) {
      this.$emit('handleNodeClick', item);
    },
    // 搜索第一个输入框条件
    searchFirst() {
      this.$emit('searchFirst', this.firstKeyword);
    },
    // 搜索第二个输入框条件
    searchSecond() {
      this.$emit('searchSecond', this.secondKeyword);
    },
    // 搜索第三个输入框条件
    searchThire() {},
    // 清空input
    clearInput() {
      this.$emit('clearInput');
    },
    // 点击左侧按钮添加到右侧
    pushToRight() {
      this.objList = Array.from(new Set(this.objList.concat(this.obj)));
      this.objList = this.objList.map((item) => {
        return {
          ...item,
          checked: false
        };
      });
      this.leftAllChecked = false;
      this.leftList.forEach((item) => {
        if (this.objList.some((v) => v.key === item.key)) {
          this.$set(item, 'checked', true);
          this.$set(item, 'disabled', true);
        }
      });
      this.obj = [];
    },
    // 点击右侧按钮添加到左侧
    delFromRight() {
      const arr = [];
      this.objList.forEach((item) => {
        if (item.checked === false) {
          arr.push(item);
        }
      });
      this.objList = arr;
      this.leftList.forEach((item) => {
        if (this.objList.some((v) => v.key === item.key)) {
          this.$set(item, 'checked', true);
          this.$set(item, 'disabled', true);
        } else {
          this.$set(item, 'checked', false);
          this.$set(item, 'disabled', false);
        }
      });
      this.rightAllChecked = false;
    },
    // 获取已经选中的
    getSelectedVal() {
      this.$emit('getSelectedVal', this.objList);
    }
  }
};
</script>

<style lang="scss" scoped>
.title-head {
  background: #f5f5f9;
  height: 40px;
  text-align: left;
  line-height: 40px;
  padding-left: 12px;
}

::v-deep {
  .el-checkbox__input {
    position: relative;
    top: -1px;
  }

  .el-checkbox__label {
    margin-left: -2px !important;
  }

  .el-tree-node__content {
    box-sizing: border-box;
  }
  .tree-container .el-scrollbar__view {
    padding: 0px 10px;
  }
}

.transfer-left-container,
.tree-container,
.transfer-right-container {
  width: 260px !important;
  padding-bottom: 16px;
  min-height: 300px !important;
  max-height: calc(100vh - 170px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.btn-container {
  margin-left: 20px;
  margin-right: 20px;

  .el-button--small {
    margin-right: 0;
  }
}
</style>
